import { axios } from '$app-web/api/axios';

import { Endpoints } from './constant';

interface ResetParticipantByParticipantParams {
    studyId: number;
}

interface ResetParticipantByResearcherParams {
    studyId: number;
    ownerId: number;
    reason: string;
}

export async function resetParticipantByParticipant({ studyId }: ResetParticipantByParticipantParams) {
    const requestBody = { study_id: studyId };
    const response = await axios.post(Endpoints.Registration.ResetParticipationByParticipant, requestBody);
    return response;
}

export async function resetParticipantByResearcher({ studyId, ownerId, reason }: ResetParticipantByResearcherParams) {
    const requestBody = { study_id: studyId, owner_id: ownerId, reason };
    const response = await axios.post(Endpoints.Registration.ResetParticipationByResearcher, requestBody);
    return response;
}
